<template>
  <beer itemId="2000000001" itemName="summer-blondie" title="Summer Blondie, 13 °P, Blonde ALE">
    <p
      style="
          margin: auto;
          text-align: justify;
          max-width: 40rem;
          width: 100%;
          margin-top: 4rem;
        "
    >
      Svrchně kvašené pivo s vyšší hořkostí a intenzivním aroma. Světlá barva a mírný zákal díky vysokému podílu
      pšeničného sladu. Díky dryhoppingu je aroma citrusové s náznakem tropického ovoce. Pivo je skvěle pitelné, plné
      chuti a vhodné pro celovečerní posezení.
    </p>

    <table
      class="tg"
      style="
          margin: auto;
          text-align: left;
          max-width: 40rem;
          width: 100%;
          margin-top: 4rem;
        "
    >
      <tbody>
        <tr>
          <td class="bold">Pivní styl</td>
          <td class="right">Blonde ALE</td>
        </tr>
        <tr>
          <td>Stupňovitost</td>
          <td class="right">13 °P</td>
        </tr>
        <tr>
          <td>Alkohol</td>
          <td class="right">5.0 %</td>
        </tr>
        <tr>
          <td>Barva</td>
          <td class="right">4 SRM</td>
        </tr>
        <tr>
          <td>Hořkost</td>
          <td class="right">47 IBU</td>
        </tr>
        <tr>
          <td>Slady</td>
          <td class="right">pale ale, plzeňský, pšeničný, carared</td>
        </tr>
        <tr>
          <td>Chmely</td>
          <td class="right">Apollo, Vic Secret, Waimea</td>
        </tr>
      </tbody>
    </table>
  </beer>
</template>

<script>
import Beer from "../Beer";
export default {
  name: "SummerBlondie",
  components: { Beer },
};
</script>
